import { Filters } from "../models/shipeezi.table";

const getRelatedFilters = (filters?: Filters, relatedTable?: string, overrideColumn?: string) => {
  if (!relatedTable) return filters;
  if (!filters) return null;

  const relatedFilters: Filters = {};

  Object.keys(filters).forEach((key) => {
    const splittedKey = key.split(".");
    const [table, column] = splittedKey.length === 2 ? splittedKey : [];

    if (table && column && table === relatedTable) {
      relatedFilters[overrideColumn ?? column] = filters[key];
    }
  });

  if (Object.keys(relatedFilters).length) return relatedFilters;

  return null;
};

export default getRelatedFilters;
